
import React, { ComponentProps } from "react";
import { useIntl } from "react-intl";
import { Spinner } from "components/shared/Spinner";
import { sharedMessages } from "shared/sharedMessages";

type Props = Omit<ComponentProps<typeof Spinner>, "aria-label" | "role">;

export const LoadingSpinner: React.VFC<Props> = props => {
    const intl = useIntl();

    return <div aria-label={intl.formatMessage(sharedMessages.loadingDescr)} role="progressbar">
        <Spinner {...props} />
    </div>;
};
